import articleWispehone from "./work-articles/articleWisephone";
import articleAnimationShowcase from "./work-articles/articleAnimationShowcase";
import articleMusicVideo from "./work-articles/articleMusicVideo";

const work_av = [
  articleMusicVideo,
  articleAnimationShowcase,
  articleWispehone
]
export default work_av;